import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ComboBoxContainer = styled.div<{ $minWidth: string }>`
    align-self: stretch;
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    gap: ${theme.space[4]};
    min-width: ${(props) => props.$minWidth};
    width: 100%;
`;
